import PropTypes from 'prop-types';
import React from 'react';
import SimpleList from 'common/display/SimpleList';

const ListField = ({
  idPrefix, label, value, listElement, shortDisplay,
}) => (
  <dl className="contact-card__detail mb-4" aria-hidden="true">
    <dt id={`${idPrefix}-label`} className="font-regular-font text-text-blue">{label}</dt>
    <dd id={`${idPrefix}-value`} className="font-regular-font text-text-blue">
      <SimpleList list={value} ListElement={listElement} shortDisplay={shortDisplay} />
    </dd>
  </dl>
);

ListField.propTypes = {
  idPrefix: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.array.isRequired,
  listElement: PropTypes.func.isRequired,
  shortDisplay: PropTypes.bool,
};

ListField.defaultProps = {
  shortDisplay: false,
};

export default ListField;
